export default __webpack_public_path__ + "static/media/collapse.62926cf0.svg";